module.exports = __webpack_public_path__ + "static/img/c2.44fea89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/wave/c2.png
// module id = GZET
// module chunks = 0